import { baseApi } from "../baseApi";

const VENDOR_BASE_URL = "/vendor";

export const vendorApi = baseApi.injectEndpoints({
  tagTypes: ["Vendor"],

  endpoints: (builder) => ({
    getVendorListData: builder.query({
      query: (params) => ({
        url: `${VENDOR_BASE_URL}/list`,
        params,
      }),
      providesTags: (result) =>
        result && Array.isArray(result.data)
          ? [
              ...result.data.map(({ _id }) => ({ type: "Vendor", id: _id })),
              { type: "Vendor", id: "LIST" },
            ]
          : [{ type: "Vendor", id: "LIST" }],
    }),

    createVendorData: builder.mutation({
      query: (payload) => ({
        url: `${VENDOR_BASE_URL}/create`,
        method: "POST",
        body: payload,
      }),
      invalidatesTags: (result, error, { _id }) => [
        { type: "Vendor", id: "LIST" },
      ],
    }),

    getVendorDataDetail: builder.query({
      query: (id) => `${VENDOR_BASE_URL}/${id}`,
      providesTags: (result, error, id) => [
        { type: "Vendor", id },
        { type: "Vendor", id: "LIST" },
      ],
    }),

    updateVendorData: builder.mutation({
      query: (payload) => {
        const { _id, ...body } = payload;

        return {
          url: `${VENDOR_BASE_URL}/${_id}`,
          method: "PUT",
          body,
        };
      },
      invalidatesTags: (result, error, { _id }) => [
        { type: "Vendor", _id },
        { type: "Vendor", id: "LIST" },
      ],
    }),

    getDDLVendorList: builder.query({
      query: () => `${VENDOR_BASE_URL}/ddl`,
    }),
  }),
});
export const {
  useGetVendorListQuery,
  useLazyGetVendorListDataQuery,
  useLazyGetDDLVendorListQuery,
  useCreateVendorDataMutation,

  useGetVendorDataDetailQuery,
  useUpdateVendorDataMutation,
} = vendorApi;
